import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConDocs: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConDocMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConDocsRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConDocs", null);
            } else {
                dispatch("receivingWebConDocs"); // สถานะ กำลังบันทึก

                axios.get('/web_con_docs', {params: payload})
                    .then(function (res) {
                        dispatch("receiveWebConDocs", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveWebConDocs", null);
                    });

            }
        },
        loadWebConDocRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConDoc", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConDoc");
                axios.get('/web_con_docs/' + id).then(res => {
                    dispatch("receiveWebConDoc", res.data);
                })
            }
        },
        updateWebConDocRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConDoc");
            const formData = new FormData();
            console.log('payload')
            console.log(payload.avatarFile)
            formData.append('file', payload.avatarFile);
            formData.append('file_en', payload.avatarFileEn);
            formData.append('file_fi', payload.avatarFileFi);
            formData.append('file_fiB', payload.avatarFileFiB);
            formData.append('doc_id', payload.doc_id);
            formData.append('doc_group_tag', payload.doc_group_tag);
            formData.append('doc_type_tag', payload.doc_type_tag);

            formData.append('doc_section', payload.doc_section);

            formData.append('doc_year', payload.doc_year);
            formData.append('doc_index', payload.doc_index);


            formData.append('doc_h_image_th', payload.doc_h_image_th);
            formData.append('doc_h_image_en', payload.doc_h_image_en);
            formData.append('doc_title_th', payload.doc_title_th);
            formData.append('doc_title_en', payload.doc_title_en);
            formData.append('doc_content_th', payload.doc_content_th);
            formData.append('doc_content_en', payload.doc_content_en);

            formData.append('status_link', payload.status_link);
            formData.append('doc_h_file', payload.doc_h_file);
            formData.append('doc_h_url', payload.doc_h_url);

            formData.append('status_link_b', payload.status_link_b);
            formData.append('doc_h_file_b', payload.doc_h_file_b);
            formData.append('doc_h_url_b', payload.doc_h_url_b);


            formData.append('doc_tag', payload.doc_tag);
            formData.append('doc_tag_b', payload.doc_tag_b);

            formData.append('doc_ref', payload.doc_ref);
            formData.append('doct_date', payload.doct_date);

            formData.append('switch_lang', payload.switch_lang);
            formData.append('active', payload.active);
            formData.append('expire', payload.expire);


             axios.post('/update_con_docs', formData).then(res => {
                 dispatch("updateWebConDoc", res.data);
             })

        },
        createWebConDocRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConDoc");

            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('file_en', payload.avatarFileEn);
            formData.append('file_fi', payload.avatarFileFi);
            formData.append('file_fiB', payload.avatarFileFiB);
            formData.append('doc_id', payload.doc_id);
            formData.append('doc_group_tag', payload.doc_group_tag);
            formData.append('doc_type_tag', payload.doc_type_tag);
            formData.append('doc_section', payload.doc_section);

            formData.append('doc_year', payload.doc_year);
            formData.append('doc_index', payload.doc_index);


            formData.append('doc_h_image_th', payload.doc_h_image_th);
            formData.append('doc_h_image_en', payload.doc_h_image_en);
            formData.append('doc_title_th', payload.doc_title_th);
            formData.append('doc_title_en', payload.doc_title_en);
            formData.append('doc_content_th', payload.doc_content_th);
            formData.append('doc_content_en', payload.doc_content_en);

            formData.append('status_link', payload.status_link);
            formData.append('doc_h_file', payload.doc_h_file);
            formData.append('doc_h_url', payload.doc_h_url);

            formData.append('status_link_b', payload.status_link_b);
            formData.append('doc_h_file_b', payload.doc_h_file_b);
            formData.append('doc_h_file_b', payload.doc_h_file_b);


            formData.append('doc_tag', payload.doc_tag);
            formData.append('doc_tag_b', payload.doc_tag_b);

            formData.append('doc_ref', payload.doc_ref);
            formData.append('doct_date', payload.doct_date);

            formData.append('switch_lang', payload.switch_lang);
            formData.append('active', payload.active);
            formData.append('expire', payload.expire);


            axios.post('/web_con_docs', formData).then(res => {
                dispatch("receiveWebConDoc", res.data);

            })


        },
        deleteWebConDocRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConDoc", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConDoc", payload);

            axios.post('/delete_con_docs', payload).then(res => {
                dispatch("deleteWebConDoc", {doc_id: payload.doc_id, res: res});
            })


        },
        receiveWebConDocs({commit}, payload) {
            commit("RECEIVED_CONDOCS", payload)
        },
        receivingWebConDocs({commit}) {
            commit("RECEIVING_CONDOCS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConDoc({commit}, payload) {
            commit("RECEIVED_CONDOC", payload)
        },
        receivingWebConDoc({commit}) {
            commit("RECEIVING_CONDOCS") //call matutions --> state.isReceiving = true;
        },
        updateWebConDoc({commit}, payload) {
            commit("UPDATED_CONDOC", payload)
        },
        updatingWebConDoc({commit}) {
            commit("UPDATING_CONDOC") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConDoc({commit}, payload) {
            commit("DELETED_CONDOC", payload)
        },
        deletingWebConDoc({commit}, payload) {
            commit("DELETING_CONDOC", payload)
        },
        afterDeleteWebConDoc({commit}, payload) {
            commit("AFFTER_DELETED_CONDOC", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_CONDOCS(state, payload) {
            state.webConDocs = payload;
            state.isReceiving = false;

        },
        RECEIVING_CONDOCS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_CONDOC(state, payload) {


            if (payload.doc_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let webConDocMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConDocMessage: (state.webConDocMessage == webConDocMessage ? webConDocMessage + ' ' : webConDocMessage),

                });
            } else {
                let webConDocMessage = 'บันทึกสำเร็จ! รายการ ' + payload.doc_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConDocs: [...state.webConDocs, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConDocMessage: (state.webConDocMessage == webConDocMessage ? webConDocMessage + ' ' : webConDocMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_CONDOC(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_CONDOC(state, payload) {
            let index = state.webConDocs.findIndex(p => p.doc_id === payload.doc_id);
            let webConDocMessage = 'บันทึกสำเร็จ! รายการ ' + payload.doc_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                webConDocs: state.webConDocs.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConDocMessage: (state.webConDocMessage == webConDocMessage ? webConDocMessage + ' ' : webConDocMessage),
            })
        },
        UPDATING_CONDOC(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_CONDOC(state, payload) {


            if (payload.doc_id == undefined || payload.res.data.message == 'Relation') {
                let webConDocMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.doc_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConDocMessage: (state.webConDocMessage == webConDocMessage ? webConDocMessage + ' ' : webConDocMessage),

                });
            } else {
                let indexToDelete = state.webConDocs.findIndex(p => p.doc_id === payload.doc_id);
                let webConDocs = [...state.webConDocs];
                webConDocs.splice(indexToDelete, 1);
                let webConDocMessage = 'บันทึกสำเร็จ! รายการ ' + payload.doc_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConDocs: [...webConDocs],
                    isDeleting: false,
                    idToDelete: null,
                    webConDocMessage: (state.webConDocMessage == webConDocMessage ? webConDocMessage + ' ' : webConDocMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_CONDOC(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.doc_id;
        },
        AFFTER_DELETED_CONDOC(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
